import axios from 'axios';

import { charsheetAPI, TABLE_CHARS, DEFAULT_CAMPAIGN } from '../../../globals.js';

async function DELETE_CHAR(characterName = "", campaign = DEFAULT_CAMPAIGN) {

    // delete the character data in postData to dynamoDB

    console.log('deleting '+ characterName + ' from campaign: ' + campaign);

    const charsheetTable = TABLE_CHARS

    let deleteName = characterName; // default to the character name passed in

    // CONFIRM the name to delete

    var confirmDelete = window.confirm("Are you sure you want to delete " + deleteName + "?  \n\n** CAUTION - ALL DELETES PERMANENT **\n\nConsider Characters > Save Local Backup first");
    if (confirmDelete === false) {
        console.log('User cancelled the delete prompt.');
        return 'User Cancelled'; 
    }

    /* SHORTCUTS for our favorite characters

    if (deleteName === 'Lanora') { deleteName = 'Lanora Snugglebottom'; } 
    if (deleteName === 'Yarg') { deleteName = 'Yarg Smashskull'; } 
    if (deleteName === 'Gerald') { deleteName = 'Gerald the Bold'; }
    if (deleteName === 'Sylonnus') { deleteName = 'Sylonnus Transvexus'; }
    
    */

    // set up the API URL for the delete request
    const API_URL = charsheetAPI + '?TableName=' + charsheetTable + '&campaign=' + campaign + '&name=' + deleteName;

    let res = { data: {} };
    try {
        res = await axios({
            host: charsheetAPI,
            method: 'DELETE',
            url: API_URL,
            headers: { 'content-type': 'text/plain' },
            withCredentials: true,
            data: { },   // this is the 'body' in AWS
        });

        console.log('DELETE_CHAR response:', res.data);
        
    } catch (error) {
        if (error.response) {
            alert(error.response.data);
            if (error.response.data === "insufficient user permissions") {
                alert('Access denied. Probably not your character.');
            }
        }
        console.error('Error deleting character:', error.response ? error.response : error.message);
        res.data = error;
    }

    // error checking needed here !!  

    return res.data;
}

export default DELETE_CHAR